/* eslint-disable */
import React, { useEffect, useRef, useState } from 'react';
import CryptoJS from 'crypto-js';
import toast from 'react-hot-toast';
import AppContext from './AppContext';
import useIEReducer from './Reducer';
import { getUrl } from '../Network/urls';
import { logout, tokenExpire } from '../Utils';
import { useLocation } from 'react-router-dom';
import { useHistory } from 'react-router-dom';

export default function Provider({ children }) {
  const [state, dispatch] = useIEReducer();
  const [secretAccessKey, setSecretAccessKey] = useState();
  const [secretAccessId, setSecretAccessId] = useState('');
  const [clientDetails, setClientDetails] = useState({});
  const { pathname } = useLocation();
  const pathnameRef = useRef(pathname);
  const REFRESH_INTERVAL = 27 * 60 * 1000 // 27 mins
  const extraTime = useRef(null);
  const accessTimeoutRef = useRef(null);
  const isSessionActiveRef = useRef(true);
  const [isAccessTokenUpdate, setIsAccessTokenUpdate] = useState(false);

  let inputFileAccess;
  let gridInputAccess;
  let gridUploadAccess;

  if (clientDetails?.file_input_access?.toLowerCase() === 'true')
    inputFileAccess = true;
  else
    inputFileAccess = false;

  if (clientDetails?.grid_input_access?.toLowerCase() === 'true')
    gridInputAccess = true;
  else
    gridInputAccess = false;

  if (clientDetails?.grid_upload_access?.toLowerCase() === 'true')
    gridUploadAccess = true;
  else
    gridUploadAccess = false;



  // const [secretAccessIdDemo, setSecretAccessIdDemo] = useState(''); // secretAccessId Demo
  const [inputBucketName, setInputBucketName] = useState('');
  // const [inputBucketNameDemo, setInputBucketNameDemo] = useState(''); // input bucket name demo
  const [productCode, setProductCode] = useState('');
  const [regulationCode, setRegulationCode] = useState('');
  const [refRowData, setRefRowData] = useState([]);
  const [refColumnData, setRefColumnData] = useState([]);
  // const [encryptIv, setEncryptIv] = useState(localStorage.getItem('RegAssureVal7'));
  // const secretKey = localStorage.getItem('userToken')?.slice(27, 47);
  const [encryptedClientValuesObj, setEncryptedClientValuesObj] = useState({});

  const handleDataDecryption = (encryptedString, secretKey) => {
    try {
      const bytes = CryptoJS.AES.decrypt(encryptedString, secretKey);
      const decryptedData = bytes.toString(CryptoJS.enc.Utf8);
      return decryptedData;
    } catch (error) {
      console.error(error.message);
      toast.error('Failed to decrypt data')
      return null;
    }
  };
  // store clientDetails only at the time of login after that it should update 
  const handleDataEncryption = (key, data, secretString, location = 'random') => {  // location is only used for the at the login time to store the clientDetails in localStorage and sessionStorage
    try {
      const encrptedString = CryptoJS.AES.encrypt(
        data,
        secretString.toString(),
      );
      if (key === 'RegAssureVal6' || key === 'RegAssureVal5' || key === 'RegAssureVal4') {
        sessionStorage.setItem(key, encrptedString.toString())
        if (location === 'login') {
          localStorage.setItem(key, encrptedString.toString())
        }
      } else {
        localStorage.setItem(key, encrptedString);
      }
      return encrptedString;
    } catch (error) {
      toast.error('Failed to encrypt data');
      console.error(error);
      return null;
    }
  };

  const handleEncryptValue = (data) => { // params of APIs
    // console.log(data, '---dataStoreProvider');
    const rawToken = localStorage.getItem('RegAssureVal7');
    if (rawToken === null)
      return null;
    const encryptionKey = rawToken.slice(-32);
    // console.log('encryptionKey :', encryptionKey);
    if (encryptionKey !== null) {
      try {
        const keyBytes = CryptoJS.enc.Utf8.parse(encryptionKey);
        const dataToEncrypt = typeof data === 'string' ? data : JSON.stringify(data);
        const iv = CryptoJS.lib.WordArray.random(16);
        const encrypted = CryptoJS.AES.encrypt(dataToEncrypt, keyBytes, {
          iv: iv,
          mode: CryptoJS.mode.CBC,
          padding: CryptoJS.pad.Pkcs7,
        });
        const ivAndCiphertext = iv.concat(encrypted.ciphertext).toString(CryptoJS.enc.Base64);
        return ivAndCiphertext;
      } catch (error) {
        console.error('Encryption failed:', error);
        toast.error('Failed to encrypt params')
        return null;
      }
    }
    return null;
  };

  const handleDecryptedValue = (encryptedString) => {
    const rawToken = localStorage.getItem('RegAssureVal7');
    if (rawToken === null)
      return null;
    const encryptionKey = rawToken.slice(-32);
    try {
      const keyBytes = CryptoJS.enc.Utf8.parse(encryptionKey);
      const encryptedDataBytes = CryptoJS.enc.Base64.parse(encryptedString);
      const iv = CryptoJS.lib.WordArray.create(encryptedDataBytes.words.slice(0, 4), 16);
      const ciphertext = CryptoJS.lib.WordArray.create(encryptedDataBytes.words.slice(4),
        encryptedDataBytes.sigBytes - 16);
      const decrypted = CryptoJS.AES.decrypt(
        { ciphertext: ciphertext },
        keyBytes,
        {
          iv: iv,
          mode: CryptoJS.mode.CBC,
          padding: CryptoJS.pad.Pkcs7,
        },
      );
      const decryptedData = decrypted.toString(CryptoJS.enc.Utf8);
      return decryptedData;
    } catch (error) {
      toast.error('Failed to decrypt value')
      return null;
    }
  };

  const handleAPIEncryptValue = (data) => { // params of APIs
    // console.log(data, '---APIdataStoreProvider');
    const rawToken = localStorage.getItem('userToken');
    if (rawToken === null)
      return null
    // const encryptionKey = rawToken.slice(10, 40).toString() + 'fF';
    const encryptionKey = `${rawToken.slice(20, 50)}rX`;
    if (encryptionKey !== null) {
      try {
        const keyBytes = CryptoJS.enc.Utf8.parse(encryptionKey);
        const iv = CryptoJS.lib.WordArray.random(16);
        const encrypted = CryptoJS.AES.encrypt(data, keyBytes, {
          iv: iv,
          mode: CryptoJS.mode.CBC,
          padding: CryptoJS.pad.Pkcs7,
        });
        const ivAndCiphertext = iv.concat(encrypted.ciphertext).toString(CryptoJS.enc.Base64);
        return ivAndCiphertext;
      } catch (error) {
        console.error('Encryption failed:', error);
        toast.error('Failed to encrypt value')
        return null;
      }
    }
    return null;
  };

  const valuesToBeEncrypt = ['clientId', 'role'];
  const handleEncryptValues = (clientData) => { // clientData is client object
    const updatedEncryptedValues = { ...encryptedClientValuesObj };
    valuesToBeEncrypt.forEach((value) => {
      const encryptedString = handleEncryptValue(clientData[value]);
      updatedEncryptedValues[value] = encryptedString;
    });
    setEncryptedClientValuesObj(updatedEncryptedValues);
  };

  const handleEncryptOtherParamsOfAPI = (paramsObj) => {
    const updatedEncryptedValues = {};
    Object.keys(paramsObj).forEach((param) => {
      updatedEncryptedValues[param] = handleEncryptValue(paramsObj[param]);
    });
    return updatedEncryptedValues;
  };

  const handleGetDecryptedData = () => {
    const rawToken = localStorage.getItem('userToken');
    // console.log("rawToken :", rawToken)
    if (rawToken === null) {
      console.log(null);
    } else {
      try {
        const secretKey = rawToken.slice(27, 47);
        // const encryptedProductCode = sessionStorage.getItem('RegAssureVal5');
        // const encryptedRegulationCode = sessionStorage.getItem('RegAssureVal6');
        // const productCode = (decryptExistingUserDets(encryptedProductCode, secretKey.toString()));



        // set client details from storage to memory
        let encryptedClientDetails = sessionStorage.getItem('RegAssureVal4');
        if (encryptedClientDetails === null || encryptedClientDetails === "null") {
          encryptedClientDetails = localStorage.getItem('RegAssureVal4')
          if (encryptedClientDetails) {
            sessionStorage.setItem('RegAssureVal4', encryptedClientDetails)
          } else {
            encryptedClientDetails = null;
          }
        }
        if (!encryptedClientDetails) {
          console.error('no client details found');
          return false;
        }
        const cDets = JSON.parse(
          handleDataDecryption(encryptedClientDetails, secretKey.toString()),
        )

        setClientDetails(cDets);
        // if productCode is not exist in the the session storage take the first product from client details
        const encryptedProductCode = sessionStorage.getItem('RegAssureVal5');
        const encryptedRegulationCode = sessionStorage.getItem('RegAssureVal6');
        if (encryptedProductCode === null) {
          const subscribedProcucts = cDets?.dataAccess ?? {};
          const firstSubscribedProduct = (Object.keys(subscribedProcucts).includes('P002') ? 'P002' : Object.keys(subscribedProcucts)[0]);
          const defaultRegCode = cDets?.dataAccess?.[firstSubscribedProduct]?.[0] ?? null;
          setProductCode(firstSubscribedProduct);
          setRegulationCode(defaultRegCode);
          handleDataEncryption('RegAssureVal5', firstSubscribedProduct, secretKey);
          if (defaultRegCode) {
            handleDataEncryption('RegAssureVal6', defaultRegCode, secretKey);
          }
        } else {
          const decryptedData = handleDataDecryption(encryptedProductCode, secretKey.toString());
          if (typeof decryptedData === 'string') {
            setProductCode(decryptedData);
          } else {
            setProductCode(
              JSON.parse(decryptedData),
            );
          }
          if (encryptedRegulationCode) {
            setRegulationCode(handleDataDecryption(encryptedRegulationCode, secretKey.toString()));
          }
        }

        // console.log("encryptedClientDetails", encryptedClientDetails)
        // console.log("encryptedProductCode", encryptedProductCode)
        // console.log("encryptedRegulationCode", encryptedRegulationCode)
        // const decryptedData = handleDataDecryption(encryptedProductCode, secretKey.toString());

      } catch (error) {
        toast.error('Failed to set initial data')
        // console.log('Error :', error);
        toast.error(error);
      }
    }
  };

  const handleDecryptResponse = (encryptedData, encryptionKey, iv) => {
    try {
      const encryptedDataBytes = CryptoJS.enc.Base64.parse(encryptedData);
      const ivBytes = CryptoJS.enc.Base64.parse(iv);
      const decryptedBytes = CryptoJS.AES.decrypt(
        { ciphertext: encryptedDataBytes },
        CryptoJS.enc.Utf8.parse(encryptionKey),
        { iv: ivBytes, mode: CryptoJS.mode.CBC, padding: CryptoJS.pad.Pkcs7 },
      );
      const decryptedData = decryptedBytes.toString(CryptoJS.enc.Utf8);
      const parsedData = JSON.parse(decryptedData);
      return parsedData;
    } catch (error) {
      toast.error('Failed to decrypt response')
      return null;
    }
  };
  // file text color
  //   color: #4b95d6;
  //   color: #81beff;
  //   color: #dc3545;
  //   color: #ef5400;
  //   color: #ffc107;
  const handleTextColorOfOutputFiles = (params) => {
    const errorFileTextCases = ['ERROR', 'Error', 'ERRORS', 'Errors', 'errors', 'error'];
    const originalFileTextCases = ['ORIGINAL', 'original', 'Original'];
    const excludedFileTextCases = ['Excluded', 'EXCLUDED', 'excluded'];
    const ineligibleFileTextCases = ['InElig', 'Ineligible', 'INELIGIBLE', 'INELIG', 'inelig'];
    const holdFileTextCases = ['HOLD', 'Hold', 'hold'];
    const flattenedFileTextCases = ['flattened', 'Flattened', 'FLATTENED'];
    const filteredFileTextCases = ['filtered', 'FILTERED', 'Filtered'];
    if (errorFileTextCases.some((text) => params?.data?.FileName?.includes(text))) {
      return 'text-red';
    }
    if (originalFileTextCases.some((text) => params?.data?.FileName?.includes(text))) {
      return 'text-blue';
    }
    if (excludedFileTextCases.some((text) => params?.data?.FileName?.includes(text))) {
      return 'text-orange';
    }
    if (ineligibleFileTextCases.some((text) => params?.data?.FileName?.includes(text))) {
      return 'text-orange-light';
    }
    if (flattenedFileTextCases.some((text) => params?.data?.FileName?.includes(text))) {
      return 'text-purple';
    }
    if (filteredFileTextCases.some((text) => params?.data?.FileName?.includes(text))) {
      return 'text-yellow';
    }
    if (holdFileTextCases.some((text) => params?.data?.FileName?.includes(text))) {
      return 'text-teal';
    }
    return '';
  };

  function getFirstAndLastDate(selectedDate) {
    const inputDate = new Date(selectedDate);
    const year = inputDate.getFullYear();
    const month = inputDate.getMonth() + 1;
    const firstDay = new Date(year, month - 1, 1);
    const lastDay = new Date(year, month, 0);
    const formatDate = (date) => {
      const yyyy = date.getFullYear();
      const dd = date.getDate().toString().padStart(2, '0');
      const mm = (date.getMonth() + 1).toString().padStart(2, '0');
      return `${yyyy}-${mm}-${dd}`;
    };
    return {
      firstDay: formatDate(firstDay),
      lastDay: formatDate(lastDay),
    };
  }

  const clearAllSessionTimers = () => {
    if (accessTimeoutRef?.current) {
      clearTimeout(accessTimeoutRef.current);
      accessTimeoutRef.current = null;
    }
    if (extraTime?.current) {
      clearTimeout(extraTime.current);
      extraTime.current = null;
    }
  };

  // console.log('token ', localStorage.getItem('userToken'));

  const scheduleNextRefresh = (delayMs) => {
    clearAllSessionTimers();
    if (!isSessionActiveRef.current || pathnameRef.current === '/' || pathnameRef.current === '/login') {
      return;
    }
    const delay = Math.max(0, delayMs);
    accessTimeoutRef.current = setTimeout(() => {
      if (!isSessionActiveRef.current || pathnameRef.current === '/' || pathnameRef.current === '/login') {
        clearAllSessionTimers();
        return;
      }
      resetAccessToken();
    }, delay);
  };

  // Listen for TOKEN_REFRESHED across tabs to avoid duplicate refresh calls
  useEffect(() => {
    let authChannel;
    try {
      if (typeof BroadcastChannel !== 'undefined') {
        authChannel = new BroadcastChannel('auth');
        authChannel.onmessage = (event) => {
          if (event.data?.type === 'TOKEN_REFRESHED') {
            // console.log('Token was refreshed by another tab. Rescheduling timer...');
            setIsAccessTokenUpdate(false);
            scheduleNextRefresh(REFRESH_INTERVAL);
          }
        };
      }
    } catch (e) {
      console.error(e);
    }
    return () => {
      if (authChannel) authChannel.close();
    };
  }, []);

  const resetAccessToken = async () => {
    if (!isSessionActiveRef.current) {
      clearAllSessionTimers();
      return;
    }
    // console.log('refresh time:', new Date().toLocaleTimeString());
    const rawToken = localStorage.getItem('userToken');
    const refreshToken = localStorage.getItem('RefreshToken');
    if (!rawToken || !refreshToken) {
      clearAllSessionTimers();
      return;
    }

    // 1. Multi-Tab Guard: Check if another tab recently refreshed (<60s ago)
    const lastRefresh = Number(localStorage.getItem('refreshTime') || 0);
    const now = Date.now();
    if (lastRefresh && (now - lastRefresh) < 60000) {
      // console.log('Token already refreshed recently by another tab.');
      setIsAccessTokenUpdate(false);
      scheduleNextRefresh(REFRESH_INTERVAL - (now - lastRefresh));
      return;
    }

    // 2. Lock to prevent simultaneous calls if 2 tabs trigger at the exact same millisecond
    const LOCK_KEY = 'regassure_refresh_lock';
    const activeLock = localStorage.getItem(LOCK_KEY);
    if (activeLock && (now - Number(activeLock)) < 15000) {
      // console.log('Another tab is actively refreshing token. Waiting...');
      accessTimeoutRef.current = setTimeout(() => {
        resetAccessToken();
      }, 3000);
      return;
    }
    localStorage.setItem(LOCK_KEY, String(now));

    const executeRefresh = async () => {
      const secretKey = rawToken.slice(27, 47);
      const encryptedClientDetails = sessionStorage.getItem('RegAssureVal4');
      if (!encryptedClientDetails) {
        clearAllSessionTimers();
        logout();
        return;
      }
      const sessionClientDetails = JSON.parse(
        handleDataDecryption(encryptedClientDetails, secretKey.toString()),
      );
      const encryptedLoginClientDetails = localStorage.getItem('RegAssureVal4');
      const loginClientDetails = encryptedLoginClientDetails
        ? JSON.parse(
          handleDataDecryption(encryptedLoginClientDetails, secretKey.toString()),
        )
        : sessionClientDetails;
      const url = getUrl('get-regassurelogin-url');
      const { email } = sessionClientDetails;
      const apiPayload = {
        httpMethod: 'POST',
        parameters: {
          email,
          password: '',
          operation: 'refresh_token',
          refresh_token: localStorage.getItem('RefreshToken'),
        },
      };

      try {
        const rawLogin = await fetch(url, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json',
            'x-api-key': process.env.REACT_APP_X_API_KEY_HEADER,
          },
          body: JSON.stringify(apiPayload),
        });

        const loginRes = await rawLogin.json();
        const { statusCode, authData, body } = loginRes;
        switch (statusCode) {
          case 200: {
            localStorage.setItem('userToken', authData?.IdToken);
            localStorage.setItem('RegAssureVal7', authData.AccessToken);
            localStorage.setItem('refreshTime', Date.now());
            // toast.success('Session Extended Successfully');
            console.log('session extended')

            // Re-encrypt RegAssureVal4 in localStorage with the new secretKey so new tabs can decrypt
            const newSecretKey = authData?.IdToken?.slice(27, 47);
            if (newSecretKey && loginClientDetails && sessionClientDetails) {
              const encryptedLoginDetails = CryptoJS.AES.encrypt(
                JSON.stringify(loginClientDetails),
                newSecretKey.toString(),
              );
              const encryptedSessionDetails = CryptoJS.AES.encrypt(
                JSON.stringify(sessionClientDetails),
                newSecretKey.toString(),
              );
              localStorage.setItem('RegAssureVal4', encryptedLoginDetails.toString());
              sessionStorage.setItem('RegAssureVal4', encryptedSessionDetails.toString());
            }
            handleEncryptValues(sessionClientDetails);

            // Broadcast to other open tabs to reschedule their timers
            try {
              if (typeof BroadcastChannel !== 'undefined') {
                const authChannel = new BroadcastChannel('auth');
                authChannel.postMessage({ type: 'TOKEN_REFRESHED' });
                authChannel.close();
              }
            } catch (e) {
              console.error(e);
            }

            scheduleNextRefresh(REFRESH_INTERVAL);
            break;
          }
          case 400:
          case 401:
            toast.error(body?.message || 'Session expired, please login again.');
            logout();
            break;
          default:
            toast.error(process.env.REACT_APP_DEFAULT_ERROR_MESSAGE);
            break;
        }
      } catch (err) {
        console.error('Session extension failed:', err);
        toast.error('Session Extension Failed. Please login again.');
        tokenExpire(err, history);
      } finally {
        localStorage.removeItem(LOCK_KEY);
        if (extraTime.current) clearTimeout(extraTime.current);
        extraTime.current = setTimeout(() => {
          if (isSessionActiveRef.current && pathnameRef.current !== '/' &&
            pathnameRef.current !== '/login') {
            setIsAccessTokenUpdate(false);
          }
        }, 2000);
      }
    };

    // ─── Multi-Tab Token Refresh Coordination (Web Locks API) ───────────────────
    // `navigator` is a browser built-in global object (window.navigator) that
    // provides access to browser/device APIs. Here we use `navigator.locks`,
    // which is the Web Locks API — it lets different browser tabs/windows
    // coordinate access to a shared resource using a named lock.
    //
    // Problem: If the user has RegAssure open in multiple tabs, each tab could
    // independently detect that the token is expiring and try to refresh it at
    // the same time — causing duplicate API calls or token invalidation.
    // ─────────────────────────────────────────────────────────────────────────────

    if (navigator?.locks?.request) {
      // Web Locks API is supported — use it to coordinate across tabs.
      // Request a named lock 'regassure_token_refresh'.
      // { ifAvailable: true } means: don't queue/wait — if another tab already
      // holds this lock, the callback is called immediately with lock = null.
      await navigator.locks.request('regassure_token_refresh', { ifAvailable: true }, async (lock) => {
        if (!lock) {
          // Lock is held by another tab — that tab is already refreshing the token.
          // Wait 3 seconds for the other tab to finish, then call resetAccessToken()
          // to read the updated token from storage instead of making a duplicate API call.
          console.log('[MULTI-TAB] Lock held by another tab via Web Locks API.');
          accessTimeoutRef.current = setTimeout(() => {
            resetAccessToken();
          }, 3000);
          return;
        }
        // Proceed with the actual token refresh API call.
        // The lock is automatically released when executeRefresh() completes.
        await executeRefresh();
      });
    } else {
      // Fall back to refreshing directly without multi-tab coordination.
      await executeRefresh();
    }
  };

  const accessTokenTimer = () => {
    isSessionActiveRef.current = true;
    // set initial route for auth session
    pathnameRef.current = '/middleware';
    scheduleNextRefresh(REFRESH_INTERVAL);
  };

  useEffect(() => {
    if (!isSessionActiveRef.current) {
      clearAllSessionTimers();
      return;
    }
    if (pathnameRef.current === '/' || pathnameRef.current === '/login') {
      clearAllSessionTimers();
      return;
    }
    const refreshTime = localStorage.getItem('refreshTime');
    const rawToken = localStorage.getItem('userToken');

    if (!rawToken || !refreshTime) {
      clearAllSessionTimers();
      return;
    }

    const timeDiff = Date.now() - Number(refreshTime);
    let remaining = REFRESH_INTERVAL - timeDiff;
    if (remaining < 0) remaining = 0;
    if (remaining === 0) {
      resetAccessToken();
      return;
    }

    scheduleNextRefresh(remaining);
  }, []);

  const resetAuthSession = (route = 'login') => {
    pathnameRef.current = `/${route}`
    if (route !== '/login') {
      isSessionActiveRef.current = true;
    } else {
      clearAllSessionTimers();
      isSessionActiveRef.current = false;
      localStorage.clear();
      sessionStorage.clear();
      setIsAccessTokenUpdate(false);
    }
  };

  // useEffect(() => {
  //   pathnameRef.current = pathname;
  //   if (pathname === '/' || pathname === '/login') {
  //     clearAllSessionTimers();
  //     isSessionActiveRef.current = false
  //     localStorage.clear();
  //     setIsAccessTokenUpdate(false)
  //   }
  // }, [pathname]);


  useEffect(() => {
    // console.log("handleDecrypted data ");
    handleGetDecryptedData();
  }, []);

  useEffect(() => {
    if (clientDetails !== null && Object.keys(clientDetails).length > 0) {
      handleEncryptValues(clientDetails);
    }
  }, [clientDetails]);

  // inputFileAccess = false;

  return (
    <AppContext.Provider
      value={{
        state,
        dispatch,
        handleDataDecryption,
        handleDataEncryption,
        secretAccessKey,
        secretAccessId,
        inputBucketName,
        // inputBucketNameDemo, // input bucket name demo
        // secretAccessIdDemo, // secretAccess Id demo
        handleGetDecryptedData,
        clientDetails,
        setClientDetails,
        productCode,
        setProductCode,
        regulationCode,
        setRegulationCode,
        refColumnData,
        refRowData,
        setRefRowData,
        setRefColumnData,
        encryptedClientValuesObj,
        setEncryptedClientValuesObj,
        handleEncryptValue,
        handleEncryptValues,
        handleDecryptedValue,
        handleEncryptOtherParamsOfAPI,
        handleDecryptResponse,
        handleAPIEncryptValue,
        handleTextColorOfOutputFiles,
        getFirstAndLastDate,
        inputFileAccess,
        gridInputAccess,
        gridUploadAccess,
        resetAccessToken,
        accessTokenTimer,
        isAccessTokenUpdate,
        resetAuthSession
      }}>
      {children}
    </AppContext.Provider>
  );
}
